import CryptoJS from "crypto-js";

const EncryptionHelper = (function () {
  function getKeyAndIV(key, callback) {
    const iv = CryptoJS.lib.WordArray.random(16);
    const keyWA = typeof key === "string"
      ? CryptoJS.enc.Utf8.parse(key)
      : key;

    callback({ iv, key: keyWA });
  }

  function encryptText(cipher_alg, key, iv, text, encoding) {
    const enc = CryptoJS.AES.encrypt(text, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString(); // devuelve base64

    return encoding === "binary"
      ? CryptoJS.enc.Base64.parse(enc).toString(CryptoJS.enc.Latin1)
      : enc;
  }

  function decryptText(cipher_alg, key, iv, text, encoding) {
    const cipherParams = encoding === "binary"
      ? CryptoJS.lib.CipherParams.create({
          ciphertext: CryptoJS.enc.Latin1.parse(text)
        })
      : CryptoJS.lib.CipherParams.create({
          ciphertext: CryptoJS.enc.Base64.parse(text)
        });

    const dec = CryptoJS.AES.decrypt(cipherParams, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    return dec.toString(CryptoJS.enc.Utf8);
  }

  return {
    CIPHERS: {
      AES_128: "aes-128-cbc",
      AES_256: "aes-256-cbc"
    },
    getKeyAndIV,
    encryptText,
    decryptText
  };
})();

export default EncryptionHelper;
